import { render, staticRenderFns } from "./ArtistTrendChart.vue?vue&type=template&id=8a5e7584&scoped=true"
import script from "./ArtistTrendChart.vue?vue&type=script&lang=js"
export * from "./ArtistTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ArtistTrendChart.vue?vue&type=style&index=0&id=8a5e7584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5e7584",
  null
  
)

export default component.exports